import React, { useContext, useRef } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import UiContext from 'common/UiContext/UiContext';

import Toast from 'components/Toast';

import './toasts.scss';

const Toasts = () => {
  const { toasts } = useContext(UiContext);
  const animationRef = useRef(null);

  return (
    <TransitionGroup className='toasts'>

      {toasts?.map(({ id, ...rest }) => (
        <CSSTransition
          nodeRef={animationRef}
          key={id}
          timeout={{
            enter: 0,
            exit: 500,
          }}
          classNames='toast-animation'
        >
          <Toast id={id} ref={animationRef} {...rest} />
        </CSSTransition>
      ))}
    </TransitionGroup>
  );
};

export default Toasts;